import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';

class ReferenceNumberField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCustom: false,
    };
  }
  static propTypes = {
    referenceNumber: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }).isRequired,
    displayClass: PropTypes.string,
    interiorClass: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
  };

  handleNameChangeDropdown = (e) => {
    const refName = e.target.value;
    if (refName === 'custom') {
      this.setState({ isCustom: true }, () => {
        this.props.onChange('name', '');
      });
    } else {
      this.props.onChange('name', refName)
    }
  };
  handleNameChangeText = (e) => {
    this.props.onChange('name', e.target.value);
  };
  handleValueChange = (e) => this.props.onChange('value', e.target.value);
  handleRemove = (e) => {
    e.preventDefault();
    this.props.onRemove();
  };

  render() {
    const {
      referenceNumber: { name, value },
      refNumbersList,
      t,
    } = this.props;
    const placeholder = refNumbersList.length
      ? 'SELECT_A_TYPE'
      : 'ENTER_SHIPPER';
    if (featureEnabled(CONFIGURED_FEATURES.SSR) && !this.state.isCustom) {
      return (
        <div className={this.props.displayClass || 'reference-number-fields'}>
          <div
            className={
              this.props.interiorClass ||
              'reference-number-field flex flex-wrap content-center items-center'
            }
          >
            <div className="sm:w-1/3 w-2/5">
              <fieldset className="md:mr-2">
                <select
                  className="block w-full mb-4 form-select"
                  value={this.props.referenceNumber.name}
                  placeholder={t('SELECT_REFERENCE_NUM_TYPE')}
                  onChange={this.handleNameChangeDropdown}
                >
                  <option key="default-0" value="">
                    {t(placeholder)}
                  </option>
                  {refNumbersList.map((ref) => (
                    <option
                      name={ref.reference_number}
                      value={ref.reference_number}
                    >
                      {t(ref?.reference_number?.toUpperCase())}
                    </option>
                  ))}
                  <option value="custom">{t('CUSTOM')}</option>
                </select>
              </fieldset>
            </div>
            <div className="sm:w-2/3 w-1/2 flex items-center">
              <fieldset className="mr-2 md:w-2/3">
                <input
                  type="text"
                  className="block w-full mb-4 form-field"
                  placeholder={t('REFERENCE_NUMBER_VALUE')}
                  value={value}
                  onChange={this.handleValueChange}
                />
              </fieldset>
              <a href="#" className="mb-4" onClick={this.handleRemove}>
                <i className="fa fa-remove secondary-action" />
              </a>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={this.props.displayClass || 'reference-number-fields'}>
        <div
          className={
            this.props.interiorClass ||
            'reference-number-field flex flex-wrap content-center items-center'
          }
        >
          <div className="sm:w-1/3 w-2/5">
            <fieldset className="md:mr-2">
              <input
                type="text"
                className="w-full mb-4 block form-field"
                placeholder={t('REFERENCE_NUMBER_NAME')}
                value={name}
                onChange={this.handleNameChangeText}
              />
            </fieldset>
          </div>
          <div className="sm:w-2/3 w-1/2 flex items-center">
            <fieldset className="mr-2 md:w-2/3">
              <input
                type="text"
                className="block w-full mb-4 form-field"
                placeholder={t('REFERENCE_NUMBER_VALUE')}
                value={value}
                onChange={this.handleValueChange}
              />
            </fieldset>
            <a href="#" className="mb-4" onClick={this.handleRemove}>
              <i className="fa fa-remove secondary-action" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(ReferenceNumberField);
